import { render } from "./CommonCombo.vue?vue&type=template&id=704dcb2c&ts=true"
import script from "./CommonCombo.vue?vue&type=script&lang=ts"
export * from "./CommonCombo.vue?vue&type=script&lang=ts"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./CommonCombo.vue?vue&type=style&index=1&id=704dcb2c&lang=css"

import exportComponent from "C:\\Users\\y-sakakibara\\Documents\\Git\\workflow-system\\workflow\\frontend\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__